import UiStore from '~/state/store/Ui.store';

class RootStore {
    public constructor(
        public ui: UiStore,
    ) {
    }
}

export default RootStore;
